export const API_ROOT = "/shipper/insights";
